import { render, staticRenderFns } from "./ProductsManufacturer.vue?vue&type=template&id=d3c2aecc&"
import script from "./ProductsManufacturer.vue?vue&type=script&lang=js&"
export * from "./ProductsManufacturer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports